var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterrogation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "interrogation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49072",
    "data-name": "Path 49072",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,14.667A6.667,6.667,0,1,1,14.667,8,6.667,6.667,0,0,1,8,14.667Z",
    transform: "translate(0 0)",
    fill: "#0464ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49073",
    "data-name": "Path 49073",
    d: "M11.145,5.041A2.667,2.667,0,0,0,8,7.666a.667.667,0,1,0,1.333,0,1.333,1.333,0,0,1,1.581-1.311,1.349,1.349,0,0,1,1.067,1.063,1.333,1.333,0,0,1-.667,1.417A2.636,2.636,0,0,0,10,11.171v.5a.667.667,0,1,0,1.333,0v-.5A1.321,1.321,0,0,1,11.953,10a2.667,2.667,0,0,0-.809-4.961Z",
    transform: "translate(-2.666 -1.666)",
    fill: "#0464ab"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20783",
    "data-name": "Rectangle 20783",
    width: 1.333,
    height: 1.333,
    rx: 0.667,
    transform: "translate(7.334 11.334)",
    fill: "#0464ab"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterrogation);
export default __webpack_public_path__ + "static/media/interrogation.58848e6cad42fc9619c076b2fa50f15a.svg";
export { ForwardRef as ReactComponent };